export const weddingDate = '2023-10-26T16:00:00-04:00';
